const AUTH_ERROR_MESSAGES: Record<string, string> = {
  BANNED_USER: 'Ce compte a ete desactive. Contacte un administrateur.',
  EMAIL_NOT_VERIFIED: 'Ton email n est pas encore vérifié. Un nouveau lien de confirmation a été envoyé.',
  EMAIL_ALREADY_VERIFIED: 'Cette adresse email est déjà vérifiée.',
  EMAIL_MISMATCH: 'Cette action email ne peut pas être exécutée pour un autre compte depuis la session courante.',
  EMAIL_RATE_LIMIT_EXCEEDED: 'Trop de demandes d email sur cette période. Réessaie dans quelques minutes.',
  FAILED_TO_SEND_VERIFICATION_EMAIL: 'Impossible d envoyer l email de confirmation pour le moment.',
  INVALID_TOKEN: 'Le lien est invalide ou a expiré.',
  INVALID_EMAIL: 'Adresse email invalide.',
  INVALID_PASSWORD: 'Le mot de passe actuel est invalide.',
  INVALID_EMAIL_OR_PASSWORD: 'Email ou mot de passe invalide.',
  PASSWORD_TOO_LONG: 'Le mot de passe est trop long.',
  PASSWORD_TOO_SHORT: 'Le mot de passe est trop court.',
  PASSWORD_ALREADY_SET: 'Le mot de passe a déjà été défini pour ce compte.',
  RESET_PASSWORD_DISABLED: 'La réinitialisation du mot de passe est indisponible.',
  SESSION_NOT_FRESH: 'Cette action sensible demande une session récente. Reconnecte-toi puis réessaie.',
  TOKEN_EXPIRED: 'Le lien a expiré.',
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: 'Un compte existe déjà avec cette adresse email.',
  USER_ALREADY_EXISTS: 'Un compte existe déjà avec cette adresse email.',
  VERIFICATION_EMAIL_NOT_ENABLED: 'La vérification email est indisponible.',
  FAILED_TO_CREATE_USER: 'Impossible de créer le compte pour le moment.',
  EMAIL_PASSWORD_DISABLED: 'La connexion par email et mot de passe est indisponible.',
  CREDENTIAL_ACCOUNT_NOT_FOUND: 'Aucun mot de passe n est encore défini pour ce compte.',
  YOU_ARE_NOT_ALLOWED_TO_LIST_USERS: 'Ce compte ne peut pas consulter la liste des utilisateurs.',
  YOU_ARE_NOT_ALLOWED_TO_CREATE_USERS: 'Ce compte ne peut pas créer de nouveaux utilisateurs.',
  YOU_ARE_NOT_ALLOWED_TO_CHANGE_USERS_ROLE: 'Ce compte ne peut pas modifier les rôles utilisateurs.',
  YOU_ARE_NOT_ALLOWED_TO_BAN_USERS: 'Ce compte ne peut pas modifier le statut des utilisateurs.',
  YOU_ARE_NOT_ALLOWED_TO_DELETE_USERS: 'Ce compte ne peut pas supprimer des utilisateurs.',
  YOU_ARE_NOT_ALLOWED_TO_SET_NON_EXISTENT_VALUE: 'Le rôle demandé n est pas autorisé.',
  INVALID_ROLE_TYPE: 'Le rôle demandé est invalide.',
  YOU_CANNOT_BAN_YOURSELF: 'Tu ne peux pas désactiver ton propre compte.',
  YOU_CANNOT_REMOVE_YOURSELF: 'Tu ne peux pas supprimer ton propre compte.',
  AVATAR_IMAGE_INVALID: 'Cette image ne peut pas être utilisée comme avatar.',
  AVATAR_IMAGE_TOO_LARGE: 'Le fichier avatar dépasse la taille maximale autorisée.',
  OBJECT_STORAGE_NOT_CONFIGURED: 'Le stockage objet n est pas configuré sur cet environnement.',
  OBJECT_STORAGE_PUBLIC_URL_MISSING: 'Le stockage public des avatars n est pas correctement configuré.',
};

function extractErrorCode(error: unknown): string | null {
  if (!error || typeof error !== 'object') {
    return null;
  }

  if ('code' in error && typeof error.code === 'string') {
    return error.code;
  }

  if (
    'error' in error &&
    error.error &&
    typeof error.error === 'object' &&
    'code' in error.error &&
    typeof error.error.code === 'string'
  ) {
    return error.error.code;
  }

  if ('message' in error && typeof error.message === 'string') {
    return error.message;
  }

  return null;
}

export function getAuthErrorMessage(error: unknown): string {
  const code = extractErrorCode(error);

  if (code && code in AUTH_ERROR_MESSAGES) {
    return AUTH_ERROR_MESSAGES[code];
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return 'Une erreur est survenue. Réessaie dans un instant.';
}
